import getLocalStorage from './get-local-storage';

export { getLocalStorage };

export default getLocalStorage;
